<div class="domain-restrictions">
  @if (hasDomainRestrictions) {
    <div>
      @if (showTitle) {
        <div class="title">
          {{ 'scan_scope_subscription_info_title' | translate }}
        </div>
      }
      <div class="domains-list" aria-live="polite">
        <button
          type="button"
          class="btn btn-link btn-flat p-0"
          [ngClass]="{ 'fw-bold': boldButton }"
          #viewDomains
          (click)="viewDomains.value = viewDomains.value === 'true' ? 'false' : 'true'"
          [attr.aria-label]="(viewDomains.value === 'true' ? 'label_hide_domains' : 'label_view_available_domains') | translate"
          [attr.aria-expanded]="viewDomains.value === 'true' ? 'true' : 'false'"
        >
          @switch (viewDomains.value) {
            @case ('true') {
              <span>{{ 'label_hide_domains' | translate }}</span>
              <svg><use xlink:href="#chevron-top"></use></svg>
            }
            @default {
              <span>{{ 'label_view_available_domains' | translate }}</span>
              <svg><use xlink:href="#chevron-bottom"></use></svg>
            }
          }
        </button>
        @if (viewDomains.value === 'true') {
          <div>
            <ul class="list-unstyled">
              @for (domain of authorizedDomains; track domain) {
                <li>
                  {{ domain }}
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  }
</div>
